// InjectedHits is used to insert custom data such as the content tile from builder.io into the algolia hits

import { useRouter } from "next/compat/router";
import React,{Suspense,lazy, useEffect} from "react";
import { useState } from "react";
import { connectHits, connectInfiniteHits } from "react-instantsearch-dom";

import { connectInjectedHits } from "./connectInjectedHits";
// Desktop
export const InjectedHits = connectHits(
  connectInjectedHits(({ injectedHits }) => {
    var productArr = [];
    const router = useRouter();
    injectedHits.map(({ props }, index) => {
      if (props?.hit?.id) {
        productArr.push(
          {
            id:props.hit.id,
            name:props.hit.title,
            price:props.hit.price,
            brand:props.hit.vendor,
            variant:props.hit.variant_title,
            list: router.asPath,
            position:index
          }
          );
      }
      let chunkArray = [];
      if (productArr.length==injectedHits.length-2 || productArr.length==injectedHits.length ||productArr.length==injectedHits.length-1 ) {
        chunkArray=_.chunk(productArr, 30);
      }

      if (chunkArray.length > 0 ){
        chunkArray.forEach((element) => {
          dataLayer.push({ ecommerce: null });
          dataLayer.push({
            'event': 'ProductImpressions',
            'ecommerce': {
              'currencyCode': 'USD',
              'impressions': element
            }
          })
        })
      }
    })    
    return (
      <div className="ais-Hits">
        <ul className="ais-Hits-list">
          {injectedHits.map(({ props, type, Hit }, index) => {           
            return <Hit {...props} key={index} index={index} isMobile={false} />;            
          })}
        </ul>
      </div>
    );
  })
);

// Mobile and Tablet
export const InjectedInfiniteHits = connectInfiniteHits(
  connectInjectedHits(({ injectedHits, ...props }) => {
    // const { device } = props;
    
    // if (device === "mobile") {
    //   // Need to swap each element 18, 38, 58... everytime as array refreshes whenever load more is clicked
    //   for (let i = 18; i <= injectedHits.length; i += 20) {
    //     // swapping last and second last element because algolia cannot directly inject into the last element
    //     if (injectedHits[i] && injectedHits[i + 1]) {
    //       const temp = injectedHits[i + 1];
    //       injectedHits[i + 1] = injectedHits[i];
    //       injectedHits[i] = temp;
    //     }
    //   }
    // }
    var productArr = [];
    const router = useRouter();
    injectedHits.map(({ props }, index) => {
      if (props?.hit?.id) {
        productArr.push(
          {
            id:props.hit.id,
            name:props.hit.title,
            price:props.hit.price,
            brand:props.hit.vendor,
            variant:props.hit.variant_title,
            list: router.asPath,
            position:index
          }
          );
      }
      let chunkArray = [];
      if (productArr.length==injectedHits.length-2 || productArr.length==injectedHits.length ||productArr.length==injectedHits.length-1 ) {
        chunkArray=_.chunk(productArr, 30);
      }

      if (chunkArray.length > 0 ){
        chunkArray.forEach((element) => {
          dataLayer.push({ ecommerce: null });
          dataLayer.push({
            'event': 'ProductImpressions',
            'ecommerce': {
              'currencyCode': 'USD',
              'impressions': element
            }
          })
        })
      }
    })
    return (
      <div className="ais-Hits">
        <ul className="ais-Hits-list">
          {injectedHits.map(({ props, type, Hit }, index) => {
            return <Hit {...props} key={index} index={index} isMobile={true}/>;
          })}
        </ul>
      </div>
    );
  })
);
